import React from 'react';
import logo from './Component/home/logo.png';

function PageNotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-[#f7f8fa] px-4 text-slate-900">
      <a href="/" className="absolute left-4 top-5 sm:left-8 sm:top-8">
        <img src={logo} alt="PacifiContract" className="h-10 w-auto object-contain sm:h-12" />
      </a>
      <p className="text-5xl font-semibold tracking-tight text-[#0075ca] sm:text-6xl md:text-7xl">
        404
      </p>
      <h1 className="mt-3 text-xl font-semibold sm:text-2xl md:text-3xl">Page not found</h1>
      <p className="mt-2 max-w-md text-center text-sm text-slate-500 sm:text-base">
        Sorry, the page you are looking for does not exist or may have moved.
      </p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <a
          href="/"
          className="inline-flex items-center justify-center rounded-full bg-[#0075ca] px-5 py-2.5 text-sm font-semibold text-white no-underline transition hover:bg-[#0063ad] sm:text-base"
        >
          Go home
        </a>
        <button
          type="button"
          className="inline-flex items-center justify-center rounded-full border border-slate-300 bg-white px-5 py-2.5 text-sm font-semibold text-slate-800 transition hover:border-slate-400 sm:text-base"
          onClick={() => window.history.back()}
        >
          Go back
        </button>
      </div>
    </div>
  );
}

export default PageNotFound;
